import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import {VALUES as TABS_VALUES} from './constants/tabs.values'
import {VARIANT_CODE as CRITERIA_TYPE} from './constants/criteria.variants'
import {CRYTERIUM_TYPE as CRYTERIUM_VARIANT, CRYTERIUM_TYPE, CRYTERIUM_TYPE_LABEL} from './constants/criterium.type'
import validationSheme from './constants/validation.form'
import CriteriaFormBody from './CriteriaFormBody';

const style = theme => ({
    root: {},
    weightInput: {
        width: 180,
    },
    uploadFile: {
        marginBottom: theme.spacing(2)
    }
})

function CriteriaForm({
        classes,
        onSubmit = () => {
        },
        id,
        partId,
        initValues,
        elementList,
        selectedItems,
        demandId,
        stageId,
        showParts = true
    }) {

    const handleSubmit = async (value) => {
        onSubmit({
            ...value,
            intervalList: value.intervalList.map(({id, ...x}) => x),
        });
    }

    const getInitialValues = () => {
        if (initValues !== undefined) {
            return {
                tab: TABS_VALUES.NEW,
                parts: {
                    [partId]: true,
                },
                ...initValues,
                intervalList: initValues.intervalList.map((x, i) => ({id: i, ...x})),
            };
        }
        return {
            tab: TABS_VALUES.NEW,
            type: CRYTERIUM_VARIANT.OTHER,
            uiType: CRITERIA_TYPE.TEXT,
            otherName: '',
            description: '',
            direction: null,
            isSelected: false,
            uom: '',
            intervalList: [],
            valuesList: [],
            parts: {
                [partId]: true,
            },
            weight: '',
            attachments: null
        }
    }

    const getNames = () => {
        let selected = selectedItems.map(x => {
            if (x.type === CRYTERIUM_TYPE.OTHER ||
                x.type === CRYTERIUM_TYPE.PRICE) return x.otherName;
            return CRYTERIUM_TYPE_LABEL[x.type];
        });
        if (initValues !== undefined) {
            let initValuesName = CRYTERIUM_TYPE_LABEL[initValues.type];
            if (initValues.type === CRYTERIUM_TYPE.OTHER || initValues.type === CRYTERIUM_TYPE.PRICE) {
                initValuesName = initValues.otherName;
            }
            var index = selected.indexOf(initValuesName);
            if (index > -1) {
                selected.splice(index, 1);
            }
        }
        return selected;
    }

    return (
        <Form
            id={id}
            onSubmit={handleSubmit}
            initialValues={{
                ...getInitialValues(),
                _editable: showParts,
            }}
            validationSchema={validationSheme(getNames())}
        >
            {(formikProps) => {
                return (<CriteriaFormBody
                    formikProps={formikProps}
                    getInitialValues={getInitialValues}
                    isEdit={Boolean(initValues)}
                    initValues={initValues}
                    elementList={elementList}
                    selectedItems={selectedItems}
                    showParts={showParts}
                />)
            }}
        </Form>
    )
}

CriteriaForm.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(CriteriaForm);
